/**
 * 翻译缓存工具函数
 * 提供处理翻译缓存数据的纯函数
 */
/**
 * 解析翻译响应数据
 * 从缓存中获取的翻译数据可能是字符串或对象，这个函数统一解析为标准格式
 *
 * @param cachedItem 从缓存中获取的翻译项
 * @returns 解析后的翻译文本和分析数据
 */
export function parseTranslationResponse(cachedItem) {
    let analysisData = undefined;
    let mainTranslatedText = '';
    if (typeof cachedItem.translatedText === 'object' && cachedItem.translatedText !== null) {
        const response = cachedItem.translatedText;
        analysisData = response.analysis;
        mainTranslatedText = response.translatedText ?? '';
    }
    else if (typeof cachedItem.translatedText === 'string') {
        mainTranslatedText = cachedItem.translatedText;
    }
    else {
        mainTranslatedText = 'Cached Format Error';
        console.warn('Unknown format for cached translatedText', cachedItem.translatedText);
    }
    return { translatedText: mainTranslatedText, analysis: analysisData };
}
/**
 * 创建翻译缓存条目
 * 生成标准格式的翻译缓存条目对象
 *
 * @param params 创建缓存条目所需的参数
 * @returns 格式化的缓存条目对象
 */
export function createCacheEntry(params) {
    const { translatedText, analysis, provider: responseProvider, extraDetails, } = params.translationResponse;
    const translatedTextResult = {
        translatedText,
        ...(analysis && { analysis }),
    };
    let location;
    if (params.selection.type === 'text') {
        const { paragraphData, startOffset, endOffset } = params.selection.location;
        location = {
            type: 'text',
            paragraphId: paragraphData.id,
            startOffset,
            endOffset,
        };
    }
    else {
        // It's a PDF selection
        const { paragraphId, paragraphData, startWordId, endWordId, startWordOffset, endWordOffset, selectionRects, } = params.selection.location;
        location = {
            type: 'pdf',
            pageNumber: paragraphData?.pageNumber ?? -1,
            paragraphId,
            startWordId,
            endWordId,
            startWordOffset,
            endWordOffset,
            rects: selectionRects,
        };
    }
    return {
        documentIdentity: params.documentIdentity,
        location: location,
        originalText: params.selection.selectedText,
        translatedText: translatedTextResult,
        provider: responseProvider,
        model: extraDetails?.model,
        sourceLanguage: params.sourceLanguage,
        targetLanguage: params.targetLanguage,
        // orderId will be set by database - don't include it here
    };
}
/**
 * 完整缓存条目
 * 向缓存条目添加ID和时间戳，用于内存缓存更新
 *
 * @param entry 基本缓存条目
 * @param id 保存后的ID
 * @returns 完整的缓存条目，包含ID和时间戳
 */
export function completeCacheEntry(entry, id) {
    return {
        ...entry,
        id,
    };
}
//# sourceMappingURL=translationCacheUtils.js.map